// extracted by mini-css-extract-plugin
export default {"liveTag":"hansard-tag_liveTag__4agNC","bluesTag":"hansard-tag_bluesTag__aRdoE","margin":"hansard-tag_margin__s08zZ"};